import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { DateTimeDisplay } from "./DateTimeDisplay";
import moment from "moment";
import Box from "@mui/material/Box";
import { getCountdowns } from "./utils/cutoffDate-utils";
import { useStyles } from "./utils/cutoffDate-styles";
import clsx from "clsx";
const expiredWarning = "The time to order for this delivery date has passed. Select a later delivery date";
export const CountdownTimer = ({ countdownDate, format = "d:h:m:s", align, className, }) => {
    const [countdown, setCountdown] = useState(moment(countdownDate).diff(moment(), "seconds"));
    const classes = useStyles();
    useEffect(() => {
        const initialCountdown = moment(countdownDate).diff(moment(), "seconds");
        setCountdown(initialCountdown);
        const interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [countdownDate]);
    const { days, hours, minutes, seconds, includeDays, includeHours, includeMinutes, includeSeconds } = getCountdowns(countdown, format);
    const { showDaysColon, showHoursColon, showMinutesColon } = {
        showDaysColon: includeHours || includeMinutes || includeSeconds,
        showHoursColon: includeMinutes || includeSeconds,
        showMinutesColon: includeSeconds,
    };
    if (days + hours + minutes + seconds <= 0) {
        return _jsx(Box, { children: expiredWarning });
    }
    return (_jsxs(Box, Object.assign({ className: clsx(classes.showCounter, className, {
            [classes.alignLeft]: align === "left",
            [classes.alignCenter]: align === "center",
            [classes.alignRight]: align === "right",
        }) }, { children: [includeDays && (_jsx(DateTimeDisplay, { value: days, type: "Days", isDanger: days <= 3, showColon: showDaysColon, align: align })), includeHours && (_jsx(DateTimeDisplay, { value: hours, type: "Hours", isDanger: false, showColon: showHoursColon, align: align })), includeMinutes && (_jsx(DateTimeDisplay, { value: minutes, type: "Mins", isDanger: false, showColon: showMinutesColon, align: align })), includeSeconds && (_jsx(DateTimeDisplay, { value: seconds, type: "Seconds", isDanger: false, showColon: false, align: align }))] })));
};
